import { useContext } from 'react'

import {
  getOwnerParcelList,
  getParcelsById,
  getStreetList,
} from '../api/server-api'

import BackIcon from '../icons/BackIcon'
import IconContainer from '../icons/IconContainer'
import SearchIcon from '../icons/SearchIcon'

import Container from '../basic-components/Container'
import Content from '../basic-components/Content'
import { Header } from '../basic-components/HeaderFooter'
import HeaderTitle from '../basic-components/HeaderTitle'
import Modal from '../basic-components/Modal'

import TextSearchDialog from '../text-search/TextSearchDialog'

import QueryContext from '../context/QueryContext'

import ResultsList from './ResultsList'

export default function SearchResultsPage({ searchType, state, gotoParcelDetail, onBackClick }) {
  const { searchParams, setSearchParams } = useContext(QueryContext);
  const { open, setOpen, results, setResults} = state;

  const itemClickHandler = (e) => {
   const choice = e.target.parentNode.innerText.trim();
   const chosenItems = results.filter(item => item.text === choice);

   //console.log(choice);
   //console.log(results);
   //console.log(chosenItems[0]);
   //console.log(searchParams);

   if (chosenItems.length !== 0) {
     switch (searchType) {
       case 'Search by Tax Number':  // drop through to OwnerName on purpose
       case 'Search by Owner Name':
         // show parcel data from item.value
         const parcelId = chosenItems[0].value;
         //console.log('getting details for '  + parcelId);
         gotoParcelDetail(searchType, { parcelId });
         break;
       case 'Search by Address':
         // TODO: search for parcel by item.value(namelong) and number(how to get it)
         //console.log(searchParams);
         //console.log(chosenItems[0]);
         //console.log('getting details for ' + searchParams.streetNumber + ' ' + chosenItems[0].value);
         gotoParcelDetail(searchType, chosenItems[0]);
         break;
       default:
     }
   }
 }

  const searchButtonClickHandler = () => setOpen(true);

  const textSearchCancelHandler = () => {
    setOpen(false);
    if (!results) {
      onBackClick();
    }
  }

  const textSearchSubmitHandler = async (data) => {
    //console.log('pressed SUBMIT in SearchResultsPage');
    //console.log(searchType);
    //console.log(data);
    setOpen(false);

    setResults(null);
    setSearchParams(data);
    // set loading here??

    try {
      //console.log('SEARCH TYPE=' + searchType);
      //console.log('SEARCH DATA');
      // TODO: turn on loading
      let list;
      switch (searchType) {
        case 'Search by Tax Number':
          const { parcelId } = data;
          list = await getParcelsById(parcelId);
          setResults(list);
          // if only one go straight to detail
          if (list.length === 1) {
            const parcelId = list[0].value;
            gotoParcelDetail(searchType, { parcelId });
          }
        break;

        case 'Search by Owner Name':
          const { ownerName } = data;
          list = await getOwnerParcelList(ownerName);
          setResults(list);
          if (list.length === 1) {
            const parcelId = list[0].value;
            gotoParcelDetail(searchType, { parcelId });
          }
          break;

        case 'Search by Address':
          const { streetNumber, streetName } = data;
          list = await getStreetList(streetNumber, streetName);
          setResults(list);
          // if only one, go ahead and search
          // for parcel by street name and number
          if (list.length === 1) {
              gotoParcelDetail(searchType, list[0]);
          }
          break;

        default:
          //console.error('Invalid search type: ' + searchType);
      }
    } catch (e) {
        //console.log(e.message());
    } finally {
      // TODO: turn off loading
    }
  }

  //console.log(state);

  return (
    <>
    <Container>
      <Header>
        <IconContainer>
          <BackIcon onClick={onBackClick}/>
        </IconContainer>
        <HeaderTitle><strong>Search Results</strong></HeaderTitle>
        <IconContainer justify="right" >
          <SearchIcon onClick={searchButtonClickHandler}/>
        </IconContainer>
      </Header>
      <Content>
        {!results ? null : (
          <ResultsList
            items={results}
            onItemClick={itemClickHandler}
          />
        )}
      </Content>
    </Container>
    <Modal
      open={open}
      showCloseIcon={false}
      onClose={() => setOpen(false)}
    >
      <TextSearchDialog
        searchType={searchType}
        onCancel={textSearchCancelHandler}
        onSubmit={textSearchSubmitHandler}
      />
    </Modal>
    </>

  );
}
